import httpCommon from 'Redux/http/httpCommon'
import { Apis } from 'Redux/APIs'
import axios from 'axios'

class ReminderService {
  verifyPin(pin) {
    return httpCommon.get(`${Apis.Login_verifyPin}/${pin}`)
  }
  submit(data) {
    return httpCommon.post(`${Apis.Login_submit}`, data)
  }
  getIp() {
    return axios.get(`https://geolocation-db.com/json/`)
  }
  getFlag(data) {
    return httpCommon.get(`${Apis.Login_getFlag}/${data}`)
  }
  unSubscribe(data) {
    return httpCommon.get(`${Apis.Unsubscribe}?patientPortalPin=${data}&action=0`)
  }
  subscribe(data) {
    return httpCommon.get(`${Apis.Subscribe}?patientPortalPin=${data}&action=1`)
  }
}

export default new ReminderService()
